import { createSelector } from 'reselect';
import { getData } from 'conversations-async-data/async-data/operators/getters';
import getCurrentOwnerAsyncData from './getCurrentOwnerAsyncData';
export const getCurrentOwner = createSelector([getCurrentOwnerAsyncData], getData);